(() => {
  if (window.GemmyCommerceInitialized) return;
  window.GemmyCommerceInitialized = true;

  const scopeSelector = [
    '.gemmy-product-page',
    '.gemmy-collection-page',
    '.gemmy-search-page',
    '.gemmy-cart-page',
    '.gemmy-cart-footer',
    '.gemmy-cart-drawer',
  ].join(',');

  const pressableSelector = 'button, .button, [role="button"], summary';

  document.addEventListener('pointerdown', (event) => {
    const control = event.target.closest(pressableSelector);
    if (!control || !control.closest(scopeSelector) || control.disabled) return;
    control.classList.add('gemmy-pressed');
  });

  const clearPressed = (event) => {
    const control = event.target.closest(pressableSelector);
    if (control) control.classList.remove('gemmy-pressed');
  };

  document.addEventListener('pointerup', clearPressed);
  document.addEventListener('pointercancel', clearPressed);
  document.addEventListener('pointerleave', clearPressed, true);

  const initProductGalleries = (root = document) => {
    root.querySelectorAll(".gemmy-product-page [id^='GalleryViewer-']").forEach((viewer) => {
      if (viewer.dataset.gemmyGalleryReady === 'true') return;
      const track = viewer.querySelector('.product__media-list');
      const previous = viewer.querySelector(':scope > .slider-buttons .slider-button--prev');
      const next = viewer.querySelector(':scope > .slider-buttons .slider-button--next');
      const current = viewer.querySelector(':scope > .slider-buttons .slider-counter--current');
      const getSlides = () => [...track.querySelectorAll(':scope > .product__media-item')].filter(slide => slide.clientWidth > 0);
      const slides = track ? getSlides() : [];
      if (!track || !previous || !next || slides.length < 2) return;

      viewer.dataset.gemmyGalleryReady = 'true';

      // Measure slide positions rather than assuming clientWidth multiples. This also
      // stays correct after Shopify reorders or replaces variant-bound media.
      const offset = slide => slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      const page = () => {
        const items = getSlides();
        return items.reduce((best, slide, index) => Math.abs(offset(slide) - track.scrollLeft) < Math.abs(offset(items[best]) - track.scrollLeft) ? index : best, 0);
      };
      const sync = () => {
        const index = page();
        const previousDisabled = index === 0;
        const nextDisabled = index === getSlides().length - 1;
        if (previous.disabled !== previousDisabled) previous.disabled = previousDisabled;
        if (next.disabled !== nextDisabled) next.disabled = nextDisabled;
        if (current) current.textContent = String(index + 1);
      };
      const move = (direction) => {
        const items = getSlides();
        const target = Math.max(0, Math.min(items.length - 1, page() + direction));
        if (!items[target]) return;
        track.scrollTo({ left: offset(items[target]), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };

      viewer.addEventListener('click', (event) => {
        const button = event.target.closest('.slider-button');
        if (!button || button.closest('.slider-buttons')?.parentElement !== viewer) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        move(button.classList.contains('slider-button--next') ? 1 : -1);
      }, true);

      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(sync);
      }, { passive: true });
      const buttonStateObserver = new MutationObserver(sync);
      buttonStateObserver.observe(previous, { attributes: true, attributeFilter: ['disabled'] });
      buttonStateObserver.observe(next, { attributes: true, attributeFilter: ['disabled'] });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  };

  initProductGalleries();
  window.addEventListener('load', () => initProductGalleries());
  document.addEventListener('shopify:section:load', (event) => initProductGalleries(event.target));
})();

/* Gemmy 20-minute gift timer session v1 */
(() => {
  const key = 'gemmyGiftCountdownStartedAt';
  try {
    const stored = Number(sessionStorage.getItem(key));
    if (!Number.isFinite(stored) || stored <= 0 || stored > Date.now()) {
      sessionStorage.setItem(key, String(Date.now()));
    }
  } catch (error) {
    // Session storage may be unavailable in strict privacy modes; the product block has a safe fallback.
  }
})();
